export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const FETCH_VIDEO_ATTEMPTED = 'FETCH_VIDEO_ATTEMPTED';
export const FETCH_VIDEO_SUCCESS = 'FETCH_VIDEO_SUCCESS';
export const FETCH_VIDEO_FAILED = 'FETCH_VIDEO_FAILED';
export const UPDATE_PARAMS = 'UPDATE_PARAMS';
export const SET_PLAYER_ERROR = 'SET_PLAYER_ERROR';
export const CONFIRMED_VISIBLE = 'CONFIRMED_VISIBLE';
export const FETCH_CAPTION_URLS_ATTEMPTED = 'FETCH_CAPTIONS_ATTEMPTED';
export const FETCH_CAPTION_URLS_SUCCEEDED = 'FETCH_CAPTION_URLS_SUCCEEDED';
export const FETCH_CAPTION_URLS_FAILED = 'FETCH_CAPTION_URLS_FAILED';